import React from 'react';

const IconPoll = () => {
  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 600 600">
      <g>
        <path
          className="sm-home__poll-icon-styling"
          d="M227.1,203.3c-34.4-12.6-58.9-45.6-58.9-84.3c0-49.6,40.2-89.8,89.8-89.8s89.8,40.2,89.8,89.8c0,38.7-24.5,71.7-58.9,84.3"
        />
        <g>
          <path
            className="sm-home__poll-icon-styling"
            d="M350.7,359.5v-85.9h-0.5c0-16.9-13.7-30.7-30.7-30.7c-16.9,0-30.7,13.7-30.7,30.7"
          />
          <path
            className="sm-home__poll-icon-styling"
            d="M412.6,375.5v-85.9h-0.5c0-16.9-13.7-30.7-30.7-30.7c-16.9,0-30.7,13.7-30.7,30.7"
          />
          <path
            className="sm-home__poll-icon-styling"
            d="M412.6,321.7c0-16.9,13.7-30.7,30.7-30.7c16.9,0,30.7,13.7,30.7,30.7h0.5v161.9c0,0-3.1,46.7-25.7,76.7"
          />
          <path
            className="sm-home__poll-icon-styling"
            d="M227.1,401.1c0,8.1-6.5,14.6-14.6,14.6c-6.1,0-11.2-3.7-13.5-8.9l-21.2-31.2c0,0-38.2-45.2-65.8-22.7c0,0-19.1,11.2,0.7,40.9c19.4,29.1,52.6,83.8,52.6,83.8s51.4,76.7,130.2,82.7"
          />
          <g>
            <line className="sm-home__poll-icon-styling" x1="227.1" y1="164" x2="227.1" y2="401.1" />
            <line className="sm-home__poll-icon-styling" x1="288.9" y1="359.5" x2="288.9" y2="164" />
            <path
              className="sm-home__poll-icon-styling"
              d="M288.9,164c0-17.1-13.8-30.9-30.9-30.9c-17.1,0-30.9,13.8-30.9,30.9"
            />
          </g>
        </g>
        <g>
          <path
            className="sm-home__icon-fill"
            d="M258,58.9c-33.1,0-60,26.9-60,60c0,17.7,7.7,33.5,19.9,44.5c0.3-21.8,18-39.4,39.9-39.4c21,0,38.2,16.2,39.8,36.8c0.3,0.8,0.5,1.8,0.5,2.7c12.2-11,20-26.9,20-44.6C318,85.8,291.1,58.9,258,58.9z"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconPoll;
